// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100')
];

export const server_loads = [];

export const dictionary = {
		"/": [16],
		"/accounts": [17],
		"/accounts/login": [18],
		"/accounts/login/guest": [19],
		"/activitypub/externalInteraction": [20],
		"/admin": [21,[2]],
		"/admin/applications": [22,[2]],
		"/admin/config": [23,[2]],
		"/admin/federation": [24,[2]],
		"/admin/media": [25,[2]],
		"/admin/taglines": [26,[2]],
		"/admin/team": [27,[2]],
		"/comment/[instance]": [31],
		"/comment/[instance]/[id=integer]": [32],
		"/comment/[instance]/[id=integer]/confirm": [33],
		"/communities": [34],
		"/create": [35,[4]],
		"/create/community": [36,[4]],
		"/create/post": [37,[4]],
		"/c/[name]": [28],
		"/c/[name]/settings": [29,[3]],
		"/c/[name]/settings/team": [30,[3]],
		"/error": [38],
		"/explore/communities": [39,[5]],
		"/explore/feeds": [40,[5]],
		"/explore/topics": [41,[5]],
		"/f/[id]": [42],
		"/go": [43],
		"/go/[...link]": [44],
		"/inbox": [45,[6]],
		"/inbox/messages": [46,[6]],
		"/inbox/messages/[user_id=integer]": [47,[6]],
		"/instances": [48,[7]],
		"/instances/blocked": [49,[7]],
		"/instances/linked": [50,[7]],
		"/legal": [51],
		"/login_reset": [54],
		"/login": [52],
		"/login/guest": [53],
		"/moderation": [55,[8]],
		"/moderation/communities": [57,[8]],
		"/moderation/c/[id=integer]": [56,[8]],
		"/modlog": [58],
		"/password_change/[token]": [59],
		"/post/[instance]": [60],
		"/post/[instance]/[id=integer]": [61],
		"/post/[instance]/[id=integer]/confirm": [62],
		"/profile": [63,[9]],
		"/profile/(local_user)/blocks": [64,[9,10,11]],
		"/profile/(local_user)/blocks/communities": [65,[9,10,11]],
		"/profile/(local_user)/blocks/instances": [66,[9,10,11]],
		"/profile/(local_user)/blocks/users": [67,[9,10,11]],
		"/profile/media": [74,[9]],
		"/profile/(local_user)/password": [68,[9,10,12]],
		"/profile/(local_user)/password/2fa": [69,[9,10,12]],
		"/profile/(local_user)/password/change": [70,[9,10,12]],
		"/profile/(local_user)/password/delete": [71,[9,10,12]],
		"/profile/(local_user)/password/logins": [72,[9,10,12]],
		"/profile/(local_user)/settings": [73,[9,10]],
		"/profile/user": [75,[9]],
		"/profile/voted/[type]": [76,[9]],
		"/registration_applications": [77],
		"/reports": [78],
		"/saved": [79],
		"/search": [80],
		"/settings": [81,[13]],
		"/settings/app": [82,[13]],
		"/settings/embeds": [83,[13]],
		"/settings/lemmy": [84,[13]],
		"/settings/moderation": [85,[13]],
		"/settings/other": [86,[13]],
		"/signup": [87,[14]],
		"/signup/[instance]": [88,[14]],
		"/theme": [89],
		"/topic/[id]": [90],
		"/translators": [91],
		"/util": [93,[15]],
		"/util/components": [94,[15]],
		"/util/constants": [95,[15]],
		"/util/functions": [96,[15]],
		"/util/instance": [97,[15]],
		"/util/photonify": [98,[15]],
		"/util/placeholder": [99,[15]],
		"/u/[name]": [92],
		"/verify_email/[token]": [100]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);